import { render, staticRenderFns } from "./BlockListBorgerDkCustom.vue?vue&type=template&id=5d17b03d&"
import script from "./BlockListBorgerDkCustom.vue?vue&type=script&lang=js&"
export * from "./BlockListBorgerDkCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports